import { BaseProductStateModel } from './../base-product-state.models';
import { BaseProductInterviewData } from '../_base-product-interview-data';
import { BaseProductService } from '../-base-product.service';
import { UserService } from '../../user/user.service';
import { Observable, of, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';


export class VeteranInterviewData extends BaseProductInterviewData {
    constructor(
        productService: BaseProductService<BaseProductStateModel>,
        userService: UserService
    ) {
        super(productService, userService);
    }

    getNotQualifiedItems(): Observable<string[]> {
        return of([
            'Not a veteran',
            'Not utilizing'
        ]);
    }

    generateNotInterestedItems(): Observable<string[]> {

        return of([
            'Privacy Concerns'
            , 'Do not solicit'
            , 'No longer Health Plan member'
            , 'Not interested'
            , 'Other'
        ]);
    }

}
